import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-stepper-step-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button [title]="stepDescription()" class="bg-transparent border-none inline-flex flex-column gap-2" (click)="onClick.emit()">
        <div class="flex justify-content-center flex-column align-items-center gap-2">
          <span class="border-round border-2 w-2rem h-2rem inline-flex align-items-center justify-content-center"
                [ngClass]="{'bg-primary border-primary': index() <= active(),'surface-border': index > active }">{{stepTitle()}}</span>
          <span class="font-bold" [ngClass]="{'surface-border': index() > active() }">{{stepDescription()}}</span>              
        </div>  
    </button>
  `,
  styles: ``
})
export class StepperStepHeaderComponent {

  stepTitle = input<string>()
  stepDescription = input<string>()
  index = input.required<number>();
  active = input.required<number>();
  onClick = output();
}
